/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Empty_EventsInputs */



/**
* | output |
* | --- |
* | "Remove Empty Events" |
*
* @param {Remove_Empty_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_empty_events = /** @type {((inputs?: Remove_Empty_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Empty_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les événements vides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Ereignisse entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi eventi vuoti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить пустые события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar eventos vacíos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除空事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空のイベントを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली इवेंट हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover eventos vazios")
	return /** @type {LocalizedString} */ ("Remove Empty Events")
});